import { apiService } from './api';

export interface EmailNotificationSettings {
    summaryEmails: string[];
    enableDailySummary: boolean;
    enableAlertEmails?: boolean;
    whatsappAutoSend?: boolean;
    whatsappEnabled?: boolean;
}

export const orgSettingsService = {
    async getEmailSettings(): Promise<EmailNotificationSettings> {
        const response = await apiService.get<EmailNotificationSettings>('/org-settings/email');
        return response.data;
    },

    async saveEmailSettings(data: EmailNotificationSettings): Promise<EmailNotificationSettings> {
        const response = await apiService.put<EmailNotificationSettings>('/org-settings/email', data);
        return response.data;
    },

    async sendSummaryNow(): Promise<{ message: string }> {
        const response = await apiService.post<{ message: string }>('/org-settings/email/send-now', {});
        return response.data;
    },
};
